import React from "react"
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {CalendarIcon} from "../../../../../assets/icons/defaultIcons";
import {Col, Row} from "react-bootstrap"
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";
import {Skeleton} from "antd";
import AvatarSkeleton from "../../../../components/skeletons/AvatarSkeleton";

export default function VaultDetailSkeleton() {
    return (
        <div className={'vault-details'}>
            <Row>
                <Col md={12}>
                    <Heading back={true} heading={'Vault Detail'}/>
                    <div className={'vault-details-section'}>
                        <div className={'left-sec'}>
                            <div className={'video-section'}>
                                <div className={'player'} style={{width: '100%', height: '600px'}}>
                                    <Skeleton.Image active={true} block={true} style={{width:'100%', height:600}} />
                                </div>
                                <h5><CalendarIcon/> <HeadingSkeleton maxWidth={200} height={15}/></h5>
                                <h3><HeadingSkeleton maxWidth={500} height={30}/></h3>
                                <p><HeadingSkeleton maxWidth={800} height={15}/></p>
                                <p><HeadingSkeleton maxWidth={800} height={15}/></p>
                                <p><HeadingSkeleton maxWidth={800} height={15}/></p>
                                <p><HeadingSkeleton maxWidth={800} height={15}/></p>
                                <div className={'tags d-flex'}>
                                    {
                                        [1, 23, 4].map((item, index) => {
                                            return (
                                                <span className={'d-flex align-items-center'} key={index}># <HeadingSkeleton maxWidth={100} height={15}/></span>
                                            )
                                        })
                                    }
                                </div>
                                <div className={'attachments'}>
                                    <h3>Attachments</h3>
                                    <div className={'attach-sec'}>
                                        {
                                            [1, 3].map((item, index) => {
                                                return (
                                                    <div className={'attachment-box'}>
                                                        <div className={'icon'}>
                                                            <HeadingSkeleton maxWidth={50} height={60}/>
                                                        </div>
                                                        <h4><HeadingSkeleton maxWidth={200} height={15}/></h4>
                                                        <p><HeadingSkeleton maxWidth={200} height={15}/></p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className={'right-sec'}>
                            <div className={'more-videos'}>
                                <h4 className={'more-head'}>More Videos</h4>
                                <div className={'more-video-sec'}>
                                    {
                                        [1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => {
                                            return (
                                                <div className={'vault-card'} >
                                                    <div className={'card-img'}>
                                                        <AvatarSkeleton avatarShape={'square'} size='large' height={160} width={'100%'}/>
                                                    </div>
                                                    <div className={'card-content'}>
                                                        <div>
                                                            <h4><HeadingSkeleton block={false} height={15} maxWidth={170} /></h4>
                                                            <h5 className={'d-flex gap-2'}> <HeadingSkeleton block={false} height={10} maxWidth={100} /></h5>
                                                        </div>
                                                        <h6><HeadingSkeleton block={false} height={10} maxWidth={100} /> <span> <AvatarSkeleton avatarShape={'circle'}  height={35} width={35}/></span></h6>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
